import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {LifestyleTrendChart} from '#component/partial';
import {sprinkles} from '#style/sprinkles';
import {theme} from '#theme';

import {LifestyleTabProps} from './LifestyleTab.types';

export const LifestyleTab = ({
  userTrends = [],
  lifestyleHealthiness = '',
  showTakeLifestyleSurvey,
}: LifestyleTabProps) => {
  return (
    <>
      <div className={sprinkles({flex: 'flex', dir: 'col'})}>
        <Text as="h3" color="burgundy" fontWeight="semiBold">
          Lifestyle Score
        </Text>
        <Text as="p" color="doveGray">
          {lifestyleHealthiness ? (
            <>{`Your current lifestyle is ${lifestyleHealthiness}`}</>
          ) : (
            'No recent results available'
          )}
        </Text>
      </div>
      <div
        className={sprinkles({display: 'grid', cols: [4, 8, 10], gap: 24, pT: [40, 64]})}
        style={{rowGap: 64}}>
        <div
          className={sprinkles({
            colSpan: [4, 8, 10],
            colStart: [1, 2, 1],
            dir: 'col',
            flex: 'flex',
            gap: 40,
          })}>
          <LifestyleTrendChart data={userTrends} />
        </div>
      </div>
      {lifestyleHealthiness && (
        <NextLink href="/lifestylesummary" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['full', 'full', 'maxContent'], mT: 48})}
            style={{
              borderStyle: 'solid',
              borderWidth: 1,
              borderColor: theme.colors.moonMist,
            }}
            icon="ArrowRight"
            variant="primary-dark">
            <Text color="inherit" variant="button">
              View Latest Summary
            </Text>
          </Button>
        </NextLink>
      )}

      {showTakeLifestyleSurvey && (
        <NextLink href="/survey" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['full', 'full', 'maxContent'], mT: 48})}
            icon="ArrowRight"
            variant="secondary">
            <Text color="inherit" variant="button">
              Take a Lifestyle Survey
            </Text>
          </Button>
        </NextLink>
      )}
    </>
  );
};
